import { Link } from 'react-router-dom';
import { PHONE_DISPLAY, PHONE_TEL } from '../../../lib/businessInfo';

export default function FaqCta() {
  return (
    <section className="bg-teal-700 py-16 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h4 className="text-2xl sm:text-3xl font-bold text-white mb-3">
          <a href="#ready-to-buy" className="hover:text-teal-100 transition-colors cursor-pointer">
            Ready to Find Your Perfect Vehicle?
          </a>
        </h4>
        <p className="text-sm text-teal-100 mb-8 max-w-2xl mx-auto leading-relaxed">
          Rockhound Auto serves Warrenton, Astoria, Seaside, Tillamook, Forest Grove, Hillsboro, Longview, Kelso, and Long Beach. Save thousands compared to Warrenton Kia, Lums Toyota, Astoria Ford, and Oceancrest Chevrolet.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/inventory"
            className="bg-white text-teal-700 px-8 py-3 rounded-full text-sm font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Browse Inventory
          </Link>
          <a
            href={`tel:${PHONE_TEL}`}
            className="border-2 border-white text-white px-8 py-3 rounded-full text-sm font-semibold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            Call {PHONE_DISPLAY}
          </a>
          <Link
            to="/contact"
            className="border-2 border-white/50 text-white px-8 py-3 rounded-full text-sm font-semibold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
}